module.exports = __webpack_public_path__ + "plat/static/media/111.1e92d232.mp4";